import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '../ui/dropdown-menu';
import { cn } from '../../lib/utils';
import { Wrench, ChevronDown } from 'lucide-react';
import { toolsNavItems } from './navItems';

const ToolsDropdown: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const isToolRouteActive = toolsNavItems.some((item) =>
    location.pathname.startsWith(item.to)
  );

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          className={cn(
            'hidden lg:flex items-center gap-2 px-3 py-2 text-[13px] rounded-md transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring',
            isToolRouteActive
              ? 'text-foreground font-medium'
              : 'text-muted-foreground hover:text-foreground'
          )}
        >
          <Wrench className="h-4 w-4" />
          Tools
          <ChevronDown className="h-3.5 w-3.5 opacity-60" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" sideOffset={8} className="w-44">
        {toolsNavItems.map((item) => {
          const isActive = location.pathname.startsWith(item.to);
          return (
            <DropdownMenuItem
              key={item.to}
              onClick={() => navigate(item.to)}
              className={cn(isActive && 'text-primary font-medium')}
            >
              <item.icon className="mr-2 h-4 w-4" />
              {item.label}
            </DropdownMenuItem>
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default ToolsDropdown;
